import { useNavigate } from "react-router-dom";
import { useGetAllPersonsQuery } from "@/services/api";
import { useAppDispatch } from "@/services/store";
import { useContainerSize } from "@/shared/hooks";
import { appRouterPaths } from "@/services/navigation";
import { setCurrentPerson } from "@/pages/ContactsPage/slice";
import type { Person } from "@/services/api";
import { CONTACTS_CARD_HEIGHT, CONTACTS_CARD_WIDTH } from "../model";
import { getLastModifiedPersons } from "./get-last-modified-persons";

export const useContactsBar = () => {
  const { data: contacts, isLoading: contactsIsLoading } = useGetAllPersonsQuery();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { containerRef, containerWidth, containerHeight, gap, paddingX, paddingY } =
    useContainerSize({ toggle: contactsIsLoading });

  const availableWidth = containerWidth - paddingX;
  const availableHeight = containerHeight - paddingY;

  const rows = Math.floor(availableWidth / (CONTACTS_CARD_WIDTH + gap));

  const columns = Math.floor(availableHeight / (CONTACTS_CARD_HEIGHT + gap));

  const cardsCount = !containerWidth || !containerHeight ? 2 : Math.floor(rows * columns);

  const contactsData = getLastModifiedPersons({
    persons: contacts?.persons ?? [],
    count: cardsCount,
  });

  const contactCardClickHandler = (person: Person) => {
    navigate(`${appRouterPaths.contacts.base}/generalInfo/${person.id}`);
    dispatch(setCurrentPerson(person));
  };

  return { containerRef, contactsData, contactCardClickHandler, contactsIsLoading };
};
